import s from './TabDiamondsType.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import Tooltip from '../Tooltip'
import naturalIcon from '@publicAssets/images/ui/tooltip/naturalIcon.jpg'
import labIcon from '@publicAssets/images/ui/tooltip/labIcon.jpg'
import Image from 'next/image'
import { useState, useRef, useEffect } from 'react'
import closeIcon from '@publicAssets/images/ui/tooltip/close-icon-tooltip.webp'
import Link from 'next/link'
import { useRouter } from 'next/router'

const TabDiamondsType = ({ type }: { type: string }) => {
  const [activeLab, setActiveLab] = useState(false)
  const [activeNatural, setActiveNatural] = useState(false)
  const router = useRouter()
  const naturalButtonRef = useRef(null)
  const labButtonRef = useRef(null)
  const [openTooltip, setOpenTooltip] = useState(false)

  const handleNaturalButton = (
    e:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    if (e.target == naturalButtonRef.current) {
      router.push('/natural-loose-diamonds')
    } else {
      activeLab === true ? setActiveLab(false) : ''
      setActiveNatural((current) => !current)
    }
  }

  const handleLabButton = (
    e:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    if (e.target == labButtonRef.current) {
      router.push('/lab-created-diamonds')
    } else {
      activeNatural === true ? setActiveNatural(false) : ''
      setActiveLab((current) => !current)
    }
  }

  const handleCloseTooltip = () => {
    setOpenTooltip(false)
  }
  useEffect(() => {
    // if route contains /lab-created-diamonds then set activeLab to true
    if (router.pathname.includes('/lab-created-diamonds')) {
      setActiveLab(true)
    }
    // if route contains /natural-loose-diamonds then set activeNatural to true
    if (router.pathname.includes('/natural-loose-diamonds')) {
      setActiveNatural(true)
    }
  }, [router.pathname])

  return (
    <div className={s.container}>
      <div className={s.item}>
        <button
          type="button"
          className={`${s.btn} ${
            type === 'natural'
              ? 'md:w-48  w-full bg-accent-9 text-white border-accent-9 text-[12px] text-base font-semibold'
              : 'md:w-48  w-full bg-white border border-black border-r-accent-9 text-gray-dark text-[12px] text-base font-semibold'
          }`}
          onClickCapture={(e) => handleNaturalButton(e)}
          ref={naturalButtonRef}
          aria-describedby="activeTooltip Know about Diamond Types"
        >
          Natural Diamonds
        </button>
      </div>

      <div className={s.item}>
        <div className="flex flex-row items-center">
          <button
            type="button"
            className={`${s.btn}
              ${
                type === 'lab'
                  ? 'md:w-48  w-full bg-accent-9 text-white border-accent-9 text-base font-semibold'
                  : 'md:w-48  w-full bg-white border border-black border-l-accent-9 text-gray-dark text-base font-semibold'
              }`}
            onClick={(e) => handleLabButton(e)}
            ref={labButtonRef}
            aria-describedby="activeTooltip Know about Diamond Types"
          >
            Lab Diamonds
          </button>
          <button
            className={`${s.iconTooltip} bg-white text-gray-dark`}
            id="activeTooltip"
            onClick={(e) => {
              e.preventDefault()
              setOpenTooltip(!openTooltip)
            }}
            aria-label="Know about Diamond Types"
          >
            <FontAwesomeIcon icon={faCircleInfo} />
            {activeLab && openTooltip && (
              <Tooltip
                title="Lab Diamonds"
                image={
                  <Image src={labIcon} width={48} height={48} alt="labImage" />
                }
                message="Lab Diamonds are grown usign technology that mimics the pressure and heat of the natural process that creates diamonds beneath the Earth's curst. 
                          They are indistinguishable from naturally diamonds since they have the exact same chemical and physical properties. "
                link={
                  <Link href="/info/diamond-education/lab-diamonds">
                    Learn more about Lab Diamonds.
                  </Link>
                }
                closeIcon={
                  <button onClick={handleCloseTooltip}>
                    <Image
                      src={closeIcon}
                      width={16}
                      height={16}
                      className="relative cursor-pointer -mr-2.5 left-[175px] top-2"
                      alt="closeIcon"
                      aria-label="closeIcon"
                    />
                  </button>
                }
                className="w-[156px] text-center md:h-[216px] md:w-[400px] md:text-justify p-2"
                activeHover={false}
              >
                {''}
              </Tooltip>
            )}
            {activeNatural && openTooltip && (
              <Tooltip
                title="Natural Diamonds"
                image={
                  <Image
                    src={naturalIcon}
                    width={48}
                    height={48}
                    alt="naturalImg"
                  />
                }
                message="Natural Diamonds are the hardest natural known substance on Earth. They are created over a period of one to three billions years, at least 85 miles below the Earth's mantle under natural conditions of very high pressure and high temperature."
                closeIcon={
                  <button onClick={handleCloseTooltip}>
                    <Image
                      src={closeIcon}
                      width={16}
                      height={16}
                      alt="closeIcon"
                    />
                  </button>
                }
                className="w-[156px] text-center md:h-[216px] md:w-[400px] md:text-justify p-2"
                activeHover={false}
              >
                {''}
              </Tooltip>
            )}
          </button>
        </div>
      </div>
    </div>
  )
}

export default TabDiamondsType
